import React from 'react';
import componentServices from 'Scripts/componentServices';
import { default as RetailModule, RetailJobsHeading } from 'Scripts/components/retailModule';
import { default as JobHeading } from 'Scripts/components/jobEdit';
import { Test } from 'Scripts/templates/test';
import { UserProfile } from 'Scripts/templates/userProfile';
import { JobOperations } from 'Scripts/templates/jobOperations';
import { JobCompositeContract } from 'Scripts/templates/jobCompositeContract';
import { JobService } from 'Scripts/templates/jobService';
import { DashboardOperationsJobs } from 'Scripts/templates/dashboardOperationsJobs';
import { DashboardOperationsCalendar } from 'Scripts/templates/dashboardOperationsCalendar';
import { DashboardOperationsPersonnel } from 'Scripts/templates/dashboardOperationsPersonnel';
import { FieldAppInspectionDashboard } from 'Scripts/templates/fieldAppInspectionDashboard';
import { FieldAppInspectionOverview } from 'Scripts/templates/fieldAppInspectionOverview';
import { FieldAppInspectionDetail } from 'Scripts/templates/fieldAppInspectionDetail';

componentServices.router.addRoutes([{
	path: '/templates/test',
	component: Test,
	contentClass: ''
},{
	path: '/templates/userProfile',
	component: UserProfile,
	contentClass: ''
},{
	path: '/templates/dashboardOperationsJobs',
	component: DashboardOperationsJobs,
	contentClass: 'jobDetail'
},{
	path: '/templates/dashboardOperationsCalendar',
	component: DashboardOperationsCalendar,
	contentClass: 'jobDetail'
},{
	path: '/templates/dashboardOperationsPersonnel',
	component: DashboardOperationsPersonnel,
	contentClass: 'jobDetail'
},{
	path: '/templates/jobOperations',
	component: JobOperations,
	contentClass: 'jobDetail jobOperations',
	heading: <header><button className='menu'><span></span><span></span><span></span></button><a className='userInfo'><span className='userPhoto'></span><span className='userName'>Jeremy Zeiders</span><span className='userModule'>Operations</span></a><div className='actions'><div><button className='action save disabled'><span>Saved</span></button></div></div><h1>Retail • <span>133 Springborough Green SW</span></h1></header>
},{
	path: '/templates/jobCompositeContract',
	component: JobCompositeContract,
	contentClass: 'jobDetail',
	heading: <header><button className='menu'><span></span><span></span><span></span></button><a className='userInfo'><span className='userPhoto'></span><span className='userName'>Jeremy Zeiders</span><span className='userModule'>Operations</span></a><div className='actions'><div><button className='action save disabled'><span>Saved</span></button></div></div><h1>Retail • <span>133 Springborough Green SW</span></h1></header>
},{
	path: '/templates/jobService',
	component: JobService,
	contentClass: 'jobDetail jobService',
	heading: <header><button className='menu'><span></span><span></span><span></span></button><a className='userInfo'><span className='userPhoto'></span><span className='userName'>Jeremy Zeiders</span><span className='userModule'>Operations</span></a><div className='actions'><div><button className='action save disabled'><span>Saved</span></button></div></div><h1>Retail • <span>133 Springborough Green SW</span></h1></header>
},{
	path: '/templates/retail-sales/jobs',
	component: ({ ...props }) => <RetailModule { ...props}><Test /></RetailModule>, // props are passed to the job because it is a PureComponent and not passing the store prevents re-render
	contentClass: 'jobDetail',
	heading: <RetailJobsHeading />
},{
	path: '/templates/fieldAppInspectionDashboard',
	component: FieldAppInspectionDashboard,
	contentClass: '',
	heading: <header><button className="menu"><span></span><span></span><span></span></button><a className="userInfo"><span className="userPhoto inspection"></span><span className="userName">Jeremy Zeiders</span><span className="userModule">Inspection</span></a><div className="actions"><div><button className="icon reload"><span></span></button></div></div><div className="logo"></div></header>
},{
	path: '/templates/fieldAppInspectionOverview',
	component: FieldAppInspectionOverview,
	contentClass: '',
	heading: <header><button className='icon iconOnly navigateBack'><span></span></button><div className="fieldInfo"><span className="title">102915.00</span><span className="subtitle">624 S. Sagewood Dr</span></div><div className="actions"><div><button className="icon iconLabel assess"><span>ASSESS</span></button></div></div></header>
},{
	path: '/templates/fieldAppInspectionDetail',
	component: FieldAppInspectionDetail,
	contentClass: '',
	heading: <header><button className='icon iconOnly navigateBack'><span></span></button><div className="fieldInfo"><span className="title">Inspection</span><span className="subtitle"><strong>102915.00</strong> 624 S. Sagewood Dr</span></div><div className="actions"><div><button className="icon iconLabel inspectionComplete"><span>COMPLETE</span></button><button className="icon pause"><span></span></button></div></div></header>
}]);
